
import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import './CostEstimatePdf.css';
import { styled } from '@mui/material/styles';
import authService from '../../features/auth/authService';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import costEstimateService from '../../features/costestimate/costEstimateService';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import moment from 'moment';
import _ from 'lodash';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,

}));


function CostEstimatePdf() {

    const date = new Date();

    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const districtId = queryParams.get('districtId');
    const academicyear = queryParams.get('academicyear');
    const selectedYear = queryParams.get('selectedYear');
    const authorization = queryParams.get('token');
    const userId = queryParams.get('userId')
    let currentDate = `${day}-${month}-${year}`;

    const [costEstimateData, setCostEstimateData] = useState(null);
    let [tabledata, setTableData] = useState([]);
    let [totalCosts, setTotalCosts] = useState([]);
    let [getDate, setDate] = useState({});
    let [isLoading, setIsLoading] = useState(true);
    let [total, setTotal] = useState(0)
    let [credit, setCredit] = useState(0)
    let [isPageLoad, setisPageLoad] = useState(false);
    let [pageBreakData, setPageBreakData] = useState([])
    let [additionalData, setAdditionalData] = useState([])
    let [otherfiledextra, setotherfiledextra] = useState('');

    useEffect(() => {
        setIsLoading(true);
        costEstimateService.getCSPageDatePdf(districtId, userId,authorization,academicyear, selectedYear || '2025-2026').then((result) => {
    
        // costEstimateService.getCSPageDatePdf(districtId, userId, authorization).then((result) => {
            console.log(" result:", result);
            setotherfiledextra(result?.data?.otherFessExtra || '');
            let updatedValue = Object.entries(result.data).map(([key, value]) => ({ [key]: value }));

            let inTableDataObject = updatedValue.find(obj => obj.hasOwnProperty('costestimateData'));
           
            if (inTableDataObject) {
                let inTableData = Object.entries(inTableDataObject.costestimateData).map(([key, value]) => ({ [key]: value }));
                inTableData.forEach((key, index) => {
                    if (key.hasOwnProperty("CalSCHLS Credits")) {
                        setTotalCosts(JSON.parse(JSON.stringify(key["CalSCHLS Credits"])));
                    }
                });

                // let inTableData = Object.entries(inTableDataObject.costestimateData).map(([key, value]) => ({ [key]: value }));
                const headerOrder = ["CHKS Basic Administration", "CHKS Reporting", "New Custom Module", "CSSS Administration", "CSPS Administration", "Additional CalSCHLS Fees","CalSCHLS Credits"];
                
                let orderedData = [];
                
                headerOrder.forEach(header => {
                    inTableData.forEach(item => {
                        if (item.hasOwnProperty(header)) {
                            orderedData.push(item);
                        }
                    });
                });
                
                console.log(orderedData);
                let nextPageData = inTableData.find(data => data.hasOwnProperty('CSPS Administration'));
                let additionalData = inTableData.find(data => data.hasOwnProperty('Additional CalSCHLS Fees'));
                if (nextPageData && additionalData) {
                    setPageBreakData(nextPageData['CSPS Administration']);
                    setAdditionalData(additionalData['Additional CalSCHLS Fees']);
                }
                console.log("inTableData :", inTableData);
                setTableData(orderedData);
            }
            // console.log("updatedValue :" , updatedValue);
            setCostEstimateData(updatedValue);
            setIsLoading(false);
            setisPageLoad(true);
        }).catch(err => {
            if (err.message) {
                // toast.error(err.message);
            } else {
                toast.error("Unable to fetch cost estimate data. Please try again later.");
            }
        });
    }, []);

    useEffect(() => {

        calculateTotal();

    }, [tabledata, total, credit,])

    const formatPhoneNumber = (phoneNumber) => {
        const cleaned = ('' + phoneNumber).replace(/\D/g, '');
        const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
        
        if (match) {
            return `${match[1]}-${match[2]}-${match[3]}`;
        }
  
        return phoneNumber;
    };
    
    const calculateTotal = () => {

        let total = 0;
        let credit = 0;

        if (tabledata) {

            tabledata.forEach(item => {
                for (const key in item) {
                    if (key !== "CalSCHLS Credits") {
                        item[key].forEach(data => {
                            total += data.value * data.unitPrice;
                        });
                    } else {
                        item[key].forEach(data => {
                            const val = parseFloat(data.value) || 0;
                            credit += val;
                        });
                    }
                }
            });

        }

        setCredit(credit)
        setTotal(total)

    }

    const TableRowStyledCSPdf = styled(TableRow)`
    &:nth-of-type(odd) {
      background-color: #EEEEEE;
      border-right : 1px solid #FFFFFF;
    }
`;

    const TableRowStyledCSPsPdf = styled(TableRow)`
&:nth-of-type(even) {
  background-color: #EEEEEE;
  border-right : 1px solid #FFFFFF;
}
`;

function formatDate(date) {
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    const year = date.getUTCFullYear();
    return `${month}-${day}-${year}`;
}

    return (
        <>

            <Grid>
                <Item className='mainCardPdf'>

                    {!isLoading ?
                        <>
                            <div className='titleClassPdf'>
                                <span style={{ width: '80%', position: 'relative' }}>
                                    <img className='schoolClimatePdf' src={require('../../assets/images/costEstimate.png')} alt='School climate health'></img>
                                    <p className='salesQuotePdf'>
                                        {costEstimateData[3]['csTitle']}
                                    </p>
                                    <span style={{ fontSize: '1.4rem', color: '#003c68', fontWeight: '400' }}>
                                        {costEstimateData[4]['csSubTitle']}
                                    </span>
                                </span>
                            </div>

                            <div className='dateClassPdf'>
                                <div className='dateClassTextPdf'>Date</div>
                                <div style={{ fontSize: '1.3rem' }}>
                                    {/* {moment(costEstimateData[5]['costEstimateOrderDate'].split('T')[0]).format('MM-DD-YYYY')} */}
                                    {costEstimateData.costEstimateOrderData === "NA"? "NA"
                                        : formatDate(new Date(costEstimateData[5]['costEstimateOrderDate']))}
                                </div>
                            </div>

                            <Grid container rowSpacing={2} className='billDetailsPdf'>
                                <Grid className='gridClasses' container item xs={6}>
                                    <div className='billBasicDetailsHeaderPdf'>Bill To:	</div>
                                    <div className='billBasicDetailsBodyPdf'>
                                        {costEstimateData[1]['districtName']} <br />
                                        {costEstimateData[14] ? costEstimateData[15]['dcName'] : ''}<br />
                                        {costEstimateData[6]['csAddress']}, {costEstimateData[7]['csCity']}, CA {costEstimateData[8]['csZipCode']}
                                    </div>
                                </Grid>

                                <Grid className='gridClasses' container item xs={6}>
                                    <div style={{ paddingBottom: '2px' }} className='billBasicDetailsHeaderPdf'>Remit To: </div>

                                    {/* {costEstimateData && costEstimateData[9]['remitTo'] == 1 ?

                                        <div className='billBasicDetailsBodyPdf'>
                                            Duerr Evaluation Resources<br></br>
                                            PO Box 674<br></br>
                                            Durham, CA 95938<br></br>
                                        </div>

                                        :  */}
                                        <div className='billBasicDetailsBodyPdf billBasicDetailsBodyPdf1'>
                                            WestEd <br />
                                            Attn: WestEd Operating Account <br />
                                            P.O. Box 889001 <br />
                                            Los Angeles, CA 90088-9001
                                            {/* </pre> */}
                                        </div>
                                    {/* } */}
                                </Grid>

                                <Grid className='gridClasses' container item xs={6}>
                                    <div style={{ paddingBottom: '2px' }} className='billBasicDetailsHeaderPdf'>Email:</div>
                                    <div className='billBasicDetailsBodyPdf'>
                                        {costEstimateData[10]['userEmail']}
                                        <br/>{costEstimateData[13]['emailExtra']}
                                    </div>
                                </Grid>

                                <Grid className='gridClasses' container item xs={6}>
                                    <div style={{ paddingBottom: '2px' }} className='billBasicDetailsHeaderPdf'>Cost Code #:</div>
                                    <div className='billBasicDetailsBodyPdf'>
                                        {costEstimateData[11]['costCode']}
                                    </div>
                                </Grid>

                                <Grid className='gridClasses' container item xs={6}>
                                    <div style={{ paddingBottom: '2px' }} className='billBasicDetailsHeaderPdf'>Phone No :</div>
                                    <div className='billBasicDetailsBodyPdf'>
                                        {formatPhoneNumber(costEstimateData[14]['phoneNumber'])}
                                    </div>
                                </Grid>

                                <Grid style={{ alignItems: 'center' }} className='gridClasses' container item xs={6}>
                                    <div className='bigTextFieldPdf' >
                                        <span className='bigTextPdf'> {costEstimateData[12].costEstimateExtra ? costEstimateData[12].costEstimateExtra : ""}</span>
                                    </div>
                                    {/* <span>{costEstimateData[12]['costEstimateExtra']}</span> */}
                                </Grid>


                            </Grid>

                            <TableContainer ref={el => {

                                if (el) {
                                    el.style.setProperty('border-radius', '0', 'important');
                                }
                            }} component={Paper} className='spacing'>
                                <Table className='tableStylePdf '>

                                    <TableHead>

                                        <TableRow >
                                            <TableCell style={{ width: '30%', }} className='standtardStyleSchool_cePdf'>Item Description</TableCell>
                                            <TableCell style={{ width: '10%', textAlign: 'center' }} className='standtardStyleSchool_cePdf'>Quantity</TableCell>
                                            <TableCell style={{ width: '10%', textAlign: 'center' }} className='standtardStyleSchool_cePdf '>Unit Price</TableCell>
                                            <TableCell style={{ width: '10%', borderRight: 'none', textAlign: 'center' }} className='standtardStyleSchool_cePdf '>Amount</TableCell>

                                        </TableRow>

                                    </TableHead>

                                    <TableBody >
                                        {tabledata ? tabledata.map((element, index) => (
                                            <>
                                          
                                                {Object.keys(element)[0] !== 'CSPS Administration' && Object.keys(element)[0] !== 'Additional CalSCHLS Fees' && Object.keys(element)[0] !== 'CalSCHLS Credits' ?
                                                    <>
                                                        <TableRow style={{ backgroundColor: (index == 0 || index == 5) ? "#EEEEEE" : '', borderBottom: 'none', marginBottom: '5px' }}>

                                                            <TableCell ref={el => {

                                                                if (el) {
                                                                    el.style.setProperty('padding', '5px 5px 5px 13px', 'important');
                                                                }
                                                            }}
                                                                style={{ fontSize: '1.2em', fontWeight: 'bold', color: '#003c68', borderBottom: 'none' }}>{Object.keys(element)[0]}
                                                            </TableCell>

                                                            {[1, 1, 1].map(() => (
                                                                <TableCell >
                                                                </TableCell>
                                                            ))}
                                                        </TableRow >

                                                        {
                                                            Object.values(element)[0].map((innerElement) => (
                                                                // <TableRow >
                                                                <TableRowStyledCSPdf>

                                                                    <TableCell className='textTablePdf' ref={el => {
                                                                        if (el) {
                                                                            el.style.setProperty('padding', '7px 9px 7px 20px', 'important');
                                                                        }
                                                                    }} style={{ borderBottom: 'none', borderRight: '1px solid #e6e6e6' }}>
                                                                        {innerElement['name']}
                                                                    </TableCell>

                                                                    <TableCell className='borderClass'
                                                                        ref={el => {
                                                                            if (el) {
                                                                                el.style.setProperty('padding', '7px 9.5px 0px 10px', 'important');
                                                                            }
                                                                        }} style={{ textAlign: 'center' }}
                                                                    >

                                                                        <span> {innerElement['value']}</span>

                                                                    </TableCell>

                                                                    <TableCell className='borderClass'
                                                                        ref={el => {
                                                                            if (el) {
                                                                                el.style.setProperty('padding', '7px 10px', 'important');
                                                                            }
                                                                        }}
                                                                    >
                                                                        {/* <span style={{ marginRight: '2px', fontWeight: '500', color: '#000000' }}>$</span>

                                                                        {innerElement['unitPrice']} */}

                                                                        <div id="main" style={{ display: "flex", flexDirection: 'row-reverse' }}>

                                                                            <div style={{ width: '30%', position: 'relative', bottom: '1px' }}>
                                                                                <span style={{ marginRight: '2px', position: 'relative', top: '2px' }}></span>
                                                                            </div>
                                                                            <div style={{ width: '40%', textAlign: 'right' }}>
                                                                                {innerElement['unitPrice']}
                                                                            </div>
                                                                            <div style={{ width: '30%', textAlign: 'right', position: 'relative', bottom: '1px' }}>
                                                                                <span style={{ marginRight: '2px', fontWeight: '500', color: 'black', position: 'relative', top: '2px' }}>$</span>
                                                                            </div>

                                                                        </div>
                                                                    </TableCell>

                                                                    <TableCell className='borderClass'
                                                                        ref={el => {
                                                                            if (el) {
                                                                                el.style.setProperty('padding', '7px 10px', 'important');
                                                                            }
                                                                        }}
                                                                        style={{ borderBottom: 'none', textAlign: 'start' }}>
                                                                        {/* <span style={{ textAlign: 'center' }}> */}
                                                                        <div id="main" style={{ display: "flex", flexDirection: 'row-reverse' }}>

                                                                            <div style={{ width: '30%', position: 'relative', bottom: '1px' }}>
                                                                                <span style={{ marginRight: '2px', position: 'relative', top: '2px' }}></span>
                                                                            </div>
                                                                            <div style={{ width: '40%', textAlign: 'right' }}>
                                                                                {parseFloat(innerElement['value'] * innerElement['unitPrice']).toFixed(2)}
                                                                            </div>
                                                                            <div style={{ width: '30%', textAlign: 'right', position: 'relative', bottom: '1px' }}>
                                                                                <span style={{ marginRight: '2px', fontWeight: '500', color: 'black', position: 'relative', top: '2px' }}>$</span>
                                                                            </div>

                                                                        </div>
                                                                    </TableCell>
                                                                    {/* </TableRow> */}
                                                                </TableRowStyledCSPdf>


                                                            ))
                                                        }
                                                    </> : ''}
                                            </>)) : ''}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            <TableContainer ref={el => {

                                if (el) {
                                    el.style.setProperty('border-radius', '0', 'important');
                                }
                            }} component={Paper}>
                                <Table className='tableStylePdf'>

                                    <TableHead>

                                        <TableRow >
                                            <TableCell style={{ width: '30%' }} className='standtardStyleSchool_cePdf'>Item Description</TableCell>
                                            <TableCell style={{ width: '10%', textAlign: 'center' }} className='standtardStyleSchool_cePdf'>Quantity</TableCell>
                                            <TableCell style={{ width: '10%', textAlign: 'center' }} className='standtardStyleSchool_cePdf '>Unit Price</TableCell>
                                            <TableCell style={{ width: '10%', borderRight: 'none', textAlign: 'center' }} className='standtardStyleSchool_cePdf '>Amount</TableCell>

                                        </TableRow>

                                    </TableHead>

                                    <TableBody >
                                        <>
                                            <TableRow style={{ backgroundColor: "#FFFFFF", borderBottom: 'none', marginBottom: '5px' }}>

                                                <TableCell ref={el => {

                                                    if (el) {
                                                        el.style.setProperty('padding', '5px 5px 5px 13px', 'important');
                                                    }
                                                }}
                                                    style={{ fontSize: '1.2em', fontWeight: '500', color: '#003c68', borderBottom: 'none' }}>CSPS Administration
                                                </TableCell>

                                                {[1, 1, 1].map(() => (
                                                    <TableCell >
                                                    </TableCell>
                                                ))}
                                            </TableRow >


                                            {pageBreakData ? pageBreakData.map((element, index) => (

                                                <TableRowStyledCSPsPdf>

                                                    <TableCell className='textTablePdf' ref={el => {
                                                        if (el) {
                                                            el.style.setProperty('padding', '7px 9px 7px 20px', 'important');
                                                        }
                                                    }} style={{ borderBottom: 'none', borderRight: '1px solid #e6e6e6' }}>
                                                        {element['name']}
                                                    </TableCell>

                                                    <TableCell className='borderClass'
                                                        ref={el => {
                                                            if (el) {
                                                                el.style.setProperty('padding', '7px 10px', 'important');
                                                            }
                                                        }} style={{ textAlign: 'center' }}
                                                    >

                                                        <span > {element['value']}</span>


                                                    </TableCell>

                                                    <TableCell className='borderClass'
                                                        ref={el => {
                                                            if (el) {
                                                                el.style.setProperty('padding', '7px 10px', 'important');
                                                            }
                                                        }}
                                                    >
                                                        <div id="main" style={{ display: "flex", flexDirection: 'row-reverse' }}>

                                                            <div style={{ width: '30%', position: 'relative', bottom: '1px' }}>
                                                                <span style={{ marginRight: '2px', position: 'relative', top: '2px' }}></span>
                                                            </div>
                                                            <div style={{ width: '40%', textAlign: 'right' }}>
                                                                {element['unitPrice']}
                                                            </div>
                                                            <div style={{ width: '30%', textAlign: 'right', position: 'relative', bottom: '1px' }}>
                                                                <span style={{ marginRight: '2px', fontWeight: '500', color: 'black', position: 'relative', top: '2px' }}>$</span>
                                                            </div>

                                                        </div>


                                                    </TableCell>

                                                    <TableCell className='borderClass'
                                                        ref={el => {
                                                            if (el) {
                                                                el.style.setProperty('padding', '7px 10px', 'important');
                                                            }
                                                        }}
                                                        style={{ borderBottom: 'none', textAlign: 'start' }}>
                                                      
                                                        <div id="main" style={{ display: "flex", flexDirection: 'row-reverse' }}>

                                                            <div style={{ width: '30%', position: 'relative', bottom: '1px' }}>
                                                                <span style={{ marginRight: '2px', position: 'relative', top: '2px' }}></span>
                                                            </div>
                                                            <div style={{ width: '40%', textAlign: 'right' }}>
                                                                {parseFloat(element['value'] * element['unitPrice']).toFixed(2)}
                                                            </div>
                                                            <div style={{ width: '30%', textAlign: 'right', position: 'relative', bottom: '1px' }}>
                                                                <span style={{ marginRight: '2px', fontWeight: '500', color: 'black', position: 'relative', top: '2px' }}>$</span>
                                                            </div>

                                                        </div>

                                                    </TableCell>
                                                    {/* </TableRow> */}
                                                </TableRowStyledCSPsPdf>
                                            )) : ''}

                                            <TableRow style={{ backgroundColor: "#EEEEEE", borderBottom: 'none', marginBottom: '5px' }}>

                                                <TableCell ref={el => {

                                                    if (el) {
                                                        el.style.setProperty('padding', '5px 5px 5px 13px', 'important');
                                                    }
                                                }}
                                                    style={{ fontSize: '1.2em', fontWeight: '500', color: '#003c68', borderBottom: 'none' }}>Additional CalSCHLS Fees

                                                </TableCell>

                                                {[1, 1, 1].map(() => (
                                                    <TableCell >
                                                    </TableCell>
                                                ))}
                                            </TableRow >

                                            {additionalData ? additionalData.map((element, index) => (

                                                <TableRowStyledCSPsPdf>

                                                    <TableCell className='textTablePdf' ref={el => {
                                                        if (el) {
                                                            el.style.setProperty('padding', '7px 9px 7px 20px', 'important');
                                                        }
                                                    }} style={{ borderBottom: 'none', borderRight: '1px solid #e6e6e6' }}>
                                                        {element['name']} 
                                                        <span style={{ marginLeft: '12px', fontSize: '14px' }}>
                                                            {otherfiledextra ? otherfiledextra : ""}
                                                        </span>
                                                    </TableCell>

                                                    <TableCell className='borderClass'
                                                        ref={el => {
                                                            if (el) {
                                                                el.style.setProperty('padding', '7px 10px', 'important');
                                                            }
                                                        }} style={{ textAlign: 'center' }}
                                                    >

                                                        {element['value']}

                                                    </TableCell>

                                                    <TableCell className='borderClass'
                                                        ref={el => {
                                                            if (el) {
                                                                el.style.setProperty('padding', '7px 10px', 'important');
                                                            }
                                                        }}
                                                    >

                                                        <div id="main" style={{ display: "flex", flexDirection: 'row-reverse' }}>

                                                            <div style={{ width: '30%', position: 'relative', bottom: '1px' }}>
                                                                <span style={{ marginRight: '2px', position: 'relative', top: '2px' }}></span>
                                                            </div>
                                                            <div style={{ width: '40%', textAlign: 'right' }}>
                                                                {element['unitPrice']}
                                                            </div>
                                                            <div style={{ width: '30%', textAlign: 'right', position: 'relative', bottom: '1px' }}>
                                                                <span style={{ marginRight: '2px', fontWeight: '500', color: 'black', position: 'relative', top: '2px' }}>$</span>
                                                            </div>

                                                        </div>
                                                    </TableCell>

                                                    <TableCell className='borderClass'
                                                        ref={el => {
                                                            if (el) {
                                                                el.style.setProperty('padding', '7px 10px', 'important');
                                                            }
                                                        }}
                                                        style={{ borderBottom: 'none', textAlign: 'start' }}>
                                                        <div id="main" style={{ display: "flex", flexDirection: 'row-reverse' }}>

                                                            <div style={{ width: '30%', position: 'relative', bottom: '1px' }}>
                                                                <span style={{ marginRight: '2px', position: 'relative', top: '2px' }}></span>
                                                            </div>
                                                            <div style={{ width: '40%', textAlign: 'right' }}>
                                                                {parseFloat(element['value'] * element['unitPrice']).toFixed(2)}
                                                            </div>
                                                            <div style={{ width: '30%', textAlign: 'right', position: 'relative', bottom: '1px' }}>
                                                                <span style={{ marginRight: '2px', fontWeight: '500', color: 'black', position: 'relative', top: '2px' }}>$</span>
                                                            </div>

                                                        </div>
                                                        {/* <span style={{ textAlign: 'center' }}>{parseFloat(element['value'] * element['unitPrice']).toFixed(2)}</span> */}
                                                    </TableCell>
                                                    {/* </TableRow> */}
                                                </TableRowStyledCSPsPdf>
                                            )) : ''}
                                        </>

                                    </TableBody>
                                </Table>
                            </TableContainer>

                            <div>
                                <div className='totalAmountPdf'>
                                    <span className='totalTextPdf'>Total Costs</span>
                                    <span className='totalNumberPdf'>
                                        {/* $ {total.toFixed(2)} */}
                                        <div id="main" style={{ display: "flex", flexDirection: 'row-reverse' }}>

                                            <div style={{ width: '30%', position: 'relative', bottom: '1px' }}>
                                                <span style={{ marginRight: '2px', position: 'relative', top: '2px' }}></span>
                                            </div>
                                            <div style={{ width: '40%', textAlign: 'right' }}>
                                                {total.toFixed(2)}
                                            </div>
                                            <div style={{ width: '30%', textAlign: 'right', position: 'relative', bottom: '1px' }}>
                                                <span style={{ marginRight: '2px', fontWeight: '500', color: 'black', position: 'relative', top: '2px' }}>$</span>
                                            </div>

                                        </div>
                                    </span>
                                </div>
                                <div className='calSchlsPdf'>CalSCHLS Credits</div>

                                <TableContainer>
                                    <Table>
                                        <TableBody>
                                            {
                                                totalCosts ? totalCosts.map((innerElement) => (
                                                    <TableRowStyledCSPdf >

                                                        <TableCell className='textTablePdf' ref={el => {
                                                            if (el) {
                                                                el.style.setProperty('padding', '7px 9px 7px 20px', 'important');
                                                            }
                                                        }} style={{ borderBottom: 'none', width: '30%', borderRight: '1px solid #e6e6e6' }}>
                                                            {innerElement['name']}
                                                        </TableCell>

                                                        <TableCell className='borderClass'
                                                            ref={el => {
                                                                if (el) {
                                                                    el.style.setProperty('padding', '4px 9px', 'important');
                                                                }
                                                            }}
                                                            style={{ width: '10%' }} >
                                                        </TableCell>

                                                        <TableCell className='borderClass'
                                                            ref={el => {
                                                                if (el) {
                                                                    el.style.setProperty('padding', '4px 9px', 'important');
                                                                }
                                                            }}
                                                            style={{ width: '10%' }} >



                                                            {/* <TextField autoComplete='off' type="number" className='inputForTable_ce inputForTable_ce_unitPrice' id="outlined-basic" variant="outlined" defaultValue={innerElement['Unit Price']} /> */}
                                                        </TableCell>

                                                        <TableCell className='borderClass'
                                                            ref={el => {
                                                                if (el) {
                                                                    el.style.setProperty('padding', '4px 9px', 'important');
                                                                }
                                                            }}
                                                            style={{ width: '10%' }}>
                                                            <div id="main" style={{ display: "flex", flexDirection: 'row-reverse' }}>

                                                                <div style={{ width: '30%', position: 'relative', bottom: '1px' }}>
                                                                    <span style={{ marginRight: '2px', position: 'relative', top: '2px' }}></span>
                                                                </div>
                                                                <div style={{ width: '40%', textAlign: 'right' }}>
                                                                    {parseFloat(innerElement['value']).toFixed(2)} 
                                                                </div>
                                                                <div style={{ width: '30%', textAlign: 'right', position: 'relative', bottom: '1px' }}>
                                                                    <span style={{ marginRight: '2px', fontWeight: '500', color: 'black', position: 'relative', top: '2px' }}>$</span>
                                                                </div>

                                                            </div>

                                                        </TableCell>
                                                    </TableRowStyledCSPdf>
                                                )) : ''
                                            }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>


                            <div className='totAmtSectionPdf'>
                                <div className='totalAmountPdf'>
                                    <span className='totalTextPdf'>Total Amount Due</span>
                                    <span className='totalNumberPdf'>
                                        <div id="main" style={{ display: "flex", flexDirection: 'row-reverse' }}>

                                            <div style={{ width: '30%', position: 'relative', bottom: '1px' }}>
                                                <span style={{ marginRight: '2px', position: 'relative', top: '2px' }}></span>
                                            </div>
                                            <div style={{ width: '40%', textAlign: 'right' }}>
                                                {(total - credit).toFixed(2)}
                                            </div>
                                            <div style={{ width: '30%', textAlign: 'right', position: 'relative', bottom: '1px' }}>
                                                <span style={{ marginRight: '2px', fontWeight: '500', color: 'black', position: 'relative', top: '2px' }}>$</span>
                                            </div>

                                        </div>


                                    </span>
                                </div>

                            </div>
                        </> : ''}
                </Item>
            </Grid >
            {isPageLoad ? <div id="pageload" ></div> : ''}
        </>
    )
}

export default CostEstimatePdf